// Static Tailwind class strings per color key so the JIT compiler keeps them.
export const CATEGORY_COLORS = [
  "blue",
  "red",
  "amber",
  "green",
  "purple",
  "teal",
  "pink",
  "indigo",
  "orange",
  "slate",
];

export const COLOR_LABELS = {
  blue: "Синьо",
  red: "Червено",
  amber: "Жълто",
  green: "Зелено",
  purple: "Лилаво",
  teal: "Тюркоаз",
  pink: "Розово",
  indigo: "Индиго",
  orange: "Оранжево",
  slate: "Сиво",
};

export const PALETTE = {
  blue: { badge: "bg-blue-50 text-blue-700 border-blue-200", solid: "bg-blue-600", text: "text-blue-700", swatch: "bg-blue-600" },
  red: { badge: "bg-red-50 text-red-600 border-red-200", solid: "bg-red-600", text: "text-red-600", swatch: "bg-red-600" },
  amber: { badge: "bg-amber-50 text-amber-700 border-amber-200", solid: "bg-amber-500", text: "text-amber-700", swatch: "bg-amber-500" },
  green: { badge: "bg-green-50 text-green-700 border-green-200", solid: "bg-green-600", text: "text-green-700", swatch: "bg-green-600" },
  purple: { badge: "bg-purple-50 text-purple-700 border-purple-200", solid: "bg-purple-600", text: "text-purple-700", swatch: "bg-purple-600" },
  teal: { badge: "bg-teal-50 text-teal-700 border-teal-200", solid: "bg-teal-600", text: "text-teal-700", swatch: "bg-teal-600" },
  pink: { badge: "bg-pink-50 text-pink-700 border-pink-200", solid: "bg-pink-600", text: "text-pink-700", swatch: "bg-pink-600" },
  indigo: { badge: "bg-indigo-50 text-indigo-700 border-indigo-200", solid: "bg-indigo-600", text: "text-indigo-700", swatch: "bg-indigo-600" },
  orange: { badge: "bg-orange-50 text-orange-700 border-orange-200", solid: "bg-orange-500", text: "text-orange-700", swatch: "bg-orange-500" },
  slate: { badge: "bg-slate-100 text-slate-700 border-slate-200", solid: "bg-slate-600", text: "text-slate-700", swatch: "bg-slate-600" },
};

export function paletteFor(color) {
  return PALETTE[color] || PALETTE.slate;
}

export const SIGNAL_STATUSES = ["Нов", "В преглед", "Разрешен", "Отхвърлен"];

export const LOCATIONS = [
  "ж.к. Левски",
  "ж.к. Хаджи Димитър",
  "ж.к. Сухата река",
  "кв. Подуяне-център",
  "бул. Ботевградско шосе",
  "бул. Владимир Вазов",
  "парк Герена",
  "Друго / не е в списъка",
];
